import { render, staticRenderFns } from "./EditingModal.vue?vue&type=template&id=58a37f1d&scoped=true&"
import script from "./EditingModal.vue?vue&type=script&lang=ts&"
export * from "./EditingModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditingModal.vue?vue&type=style&index=0&id=58a37f1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a37f1d",
  null
  
)

export default component.exports